import React from "react";
import { bool, func, node, string } from "prop-types";
import Button from "pages/_components/Button";
import { isIOS } from "react-device-detect";
import Header from "../../_components/header/Header";
import Navbar from "../../_components/Navbar";
import I18n from "../../_components/I18n";
import CustomText from "../../_components/CustomText/CustomText";
import Drawer from "../../_components/Drawer/Drawer";

const SideBar = ({ children, isDesktop, openSidebar, setOpenSidebar, onClose, title }) => {
    const handleOpenSidebar = () => {
        if (onClose) {
            onClose();
        } else {
            setOpenSidebar((state) => !state);
        }
    };

    const renderHeaderMobile = () => (
        <Header className="discount-filter-header">
            <Navbar.Item className="toolbar-view-back">
                <Button
                    className="toolbar-btn view-back"
                    onClick={handleOpenSidebar}
                    image={isIOS ? "images/figma/icon/arrow-back-mobile.svg" : "images/figma/icon/arrow-back.svg"}
                    bsStyle="link"
                    label="global.back"
                />
            </Navbar.Item>
            {title && (
                <Navbar.Item className="view-title">
                    <h1 className="title-content ">
                        <I18n id={title} />
                    </h1>
                </Navbar.Item>
            )}
        </Header>
    );

    return (
        <Drawer
            className="discounts-echeq-filter-drawer"
            enableCloseButton={isDesktop}
            openSidebar={openSidebar}
            toggleSidebar={setOpenSidebar}
            onClose={onClose}>
            {!isDesktop && renderHeaderMobile()}
            <div className="container">
                {isDesktop && title && (
                    <h2 className="title-content">
                        <CustomText text={title} textType="I18N" />
                    </h2>
                )}
                <div className="row height-100">{children}</div>
            </div>
        </Drawer>
    );
};

SideBar.propTypes = {
    children: node.isRequired,
    isDesktop: bool.isRequired,
    openSidebar: bool.isRequired,
    setOpenSidebar: func,
    onClose: func,
    title: string,
};
SideBar.defaultProps = {
    setOpenSidebar: () => {},
    onClose: null,
    title: "echecks.filter",
};

export default SideBar;
